module.exports = __webpack_public_path__ + "static/media/centre.4af87bdf.png";